"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasScope = exports.Scopes = exports.Scope = exports.SIGNING_KEY_ID = exports.RESPONSE_TYPE = exports.PROMPT = exports.AUTHORITY_URL = void 0;
exports.checkConnect = checkConnect;
const axios_1 = __importDefault(require("axios"));
exports.AUTHORITY_URL = "https://signin.rota.com/";
exports.PROMPT = "login consent";
exports.RESPONSE_TYPE = "code";
exports.SIGNING_KEY_ID = "rota";
var Scope;
(function (Scope) {
    Scope["OPENID"] = "openid";
    Scope["OFFLINE_ACCESS"] = "offline_access";
    Scope["EMAIL"] = "email";
    Scope["PROFILE"] = "profile";
    Scope["TYPE"] = "type";
    Scope["ROLES"] = "roles";
    Scope["ACTOR"] = "actor";
})(Scope || (exports.Scope = Scope = {}));
exports.Scopes = {
    ALL: Object.values(Scope),
};
/**
 * Checks if a string or array of scopes contains a particular scope
 * Null/Undefined-safe.
 */
const hasScope = (scopes, scope) => scopes !== null && scopes !== undefined
    ? (Array.isArray(scopes) ? scopes : scopes.split(" ")).includes(scope)
    : false;
exports.hasScope = hasScope;
async function checkConnect(manager) {
    const url = await manager.metadataService.getIssuer();
    const { status } = await axios_1.default.get(url);
    if (status !== 200) {
        throw new Error(`Response was ${status}`);
    }
}
